import { Component, OnInit, OnDestroy, HostListener, ViewContainerRef, Input } from '@angular/core';
import { UserSessionService } from './shared/services/user-session/user-session.service';
import { MenuItem } from './shared/models/menu-item';
import { MenuItemsService } from './shared/services/menu-items/menu-items.service';
import { SubscriptionsRemovingComponent } from './shared/components/subscription-removing/subscription-removing.component';
import { AuthService } from './login/auth/auth.service';
import { AppConfigService } from './shared/services/app-config/app-config.service';
import { SignalRManagerService } from './shared/services/signalR-manager/signal-r-manager.service';
import { SessionManager } from './shared/services/app-session-manager/session-manager.service';
import { AppUsageService } from './shared/services/app-usage-service/app-usage.service';
import { AppBootstrapperService } from './shared/services/app-bootstrapper/app-bootstrapper.service';
import { ChatbotWindowSizeService } from './shared/services/sabis-chatbot/chatbot-window-size.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './shared/components/app-header/app-header.component';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports:[CommonModule, RouterOutlet, AppHeaderComponent]
})
export class AppComponent
  extends SubscriptionsRemovingComponent
  implements OnInit, OnDestroy {
  public appMenuItems: Array<MenuItem> = [];
  public isHeaderVisible: boolean = false;
  public isChatbotPopupVisible: boolean = false;
  constructor(
    private _userSessionService: UserSessionService,
    private _authService: AuthService,
    private menuItemsService: MenuItemsService,
    private appConfig: AppConfigService,
    private _signalRManager: SignalRManagerService,
    private _appStatsService: AppUsageService,
    private _sessionManager: SessionManager,
    private _appBootstrapperService: AppBootstrapperService,
    private viewContainerRef: ViewContainerRef,
    private _chatbotWindowResizeService: ChatbotWindowSizeService,
  ) {
    super();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    const user = this._userSessionService.getUser();
    if (user) {
      const sessionId = this._userSessionService.getSessionId();
      this._appStatsService.recordBrowserClosed(user.userId, sessionId);
    }
  }

  private setHeaderVisibilityOnLoginComplete(): void {
    if (this.appConfig.config.useSDPIdentityServerAuthentication) {
      if (this._userSessionService.isSessionActive()) {
        this.isHeaderVisible = true;
      }

      super.addSubscription(
        this._authService.onCMSAuthenticationComplete.subscribe((complete) => {
          if (complete) {
            this.isHeaderVisible = true;
          }
        })
      );
    } else {
      this.isHeaderVisible = true;
    }
  }

  ngOnInit(): void {
    this._userSessionService.setViewContainer(this.viewContainerRef);
    this._appBootstrapperService.setViewContainer(this.viewContainerRef);

    this.setHeaderVisibilityOnLoginComplete();

    super.addSubscription(
      this._userSessionService.sessionStateChanged().subscribe((isActive) => { })
    );

    super.addSubscription(
      this.menuItemsService.getMenuItems().subscribe((menuItems) => {
        this.appMenuItems = menuItems;
      })
    );
    this.initSignalRConnection();

    this._chatbotWindowResizeService.chatbotPopupObservable.subscribe(result => {
      this.isChatbotPopupVisible = result;

      setTimeout(() => {
        // Try to access UTILS from window if available
        const UTILS = (window as any).UTILS;
        if (UTILS && UTILS.sizeChanged) {
          UTILS.sizeChanged.emit();
        } else {
          // Fallback to resize event
          window.dispatchEvent(new Event('resize'));
        }
      }, 150);

    });

    // Subscribe to chatbot popup visibility changes
    this._chatbotWindowResizeService.chatbotPopupObservable.subscribe(result => {
      if (result) {
        document.body.classList.add('chatbot-visible');
      } else {
        document.body.classList.remove('chatbot-visible');
        // Reset book width when chatbot is closed
        document.documentElement.style.setProperty('--chatbot-width', '0px');
      }
    });

    // Subscribe to chatbot width changes and adjust book layout
    this._chatbotWindowResizeService.chatbotWidthObservable.subscribe(width => {
      if (width > 0) {
        document.documentElement.style.setProperty('--chatbot-width', `${width}px`);
        this.updateBookWidth(width);
      }
    });

  }

  private updateBookWidth(chatbotWidth: number): void {
    const viewportWidth = window.innerWidth;
    const bookWidth = viewportWidth - chatbotWidth;
    const bookWidthPercent = (bookWidth / viewportWidth) * 100;

    // Update CSS custom property for book width
    document.documentElement.style.setProperty('--book-width', `${bookWidthPercent}%`);
    document.documentElement.style.setProperty('--book-width-px', `${bookWidth}px`);
  }

  private initSignalRConnection() {
    if (this._userSessionService.isSessionActive()) {
      this._signalRManager.initConnectionToHub(
        this._sessionManager.getToken(),
        this._userSessionService.getUser()
      );
    }
  }

  ngOnDestroy(): void {
    super.clearSubscriptions();
  }
}
